var exports = {
  "k": "x127c5a35--7d2b06--container",
};

module.exports = exports;
